import './forceLightTheme'
import './i18n'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import { client } from './client/client.gen'
import { applyCustomerContextHeader } from './lib/api-customer-context'
import { queryClient } from './lib/queryClient'
import { getRouter } from './router'

client.setConfig({ credentials: 'include' })
client.interceptors.request.use(async (request) => applyCustomerContextHeader(request))

const router = getRouter()

const rootElement = document.getElementById('app')!

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} context={{ queryClient }} />
    </QueryClientProvider>,
  )
}
